module.exports = __webpack_public_path__ + "img/3.3ca74d76.png";